'use client';

import { ReactNode, useMemo } from "react";
import * as Slider from "@radix-ui/react-slider";
import { cn } from "~/lib/utils";
interface IPriceSlider {
  minPrice: number;
  maxPrice: number;
  priceRange: [number, number];
  onChangePrice: (priceRange: [number, number]) => void;
}

export function PriceSlider({minPrice, maxPrice, onChangePrice, priceRange: [currentMin, currentMax]}: Readonly<IPriceSlider>): ReactNode {
  const values = useMemo(() => {
    return [currentMin, currentMax];
  }, [currentMin, currentMax]);

  return (
    <p className="flex flex-nowrap gap-2">
      <input
        className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-[#fff] rounded-[6px] border border-black/15 hover:bg-black/5 h-[20px] max-w-[40px] shrink-0 items-center justify-center bg-white text-center text-[14px] text-text outline-none transition-all"
        type="number"
        inputMode="numeric"
        autoFocus={false}
        autoCorrect="off"
        autoComplete="off"
        autoCapitalize="off"
        autoSave="off"
        value={currentMin}
        onChange={(event) => {
          onChangePrice([Number(event.target.value), currentMax]);
        }}
      />
      <span className="text-[14px]">€</span>
      <Slider.Root
        step={1}
        value={values}
        onValueChange={onChangePrice}
        minStepsBetweenThumbs={1}
        min={Math.round(minPrice)}
        max={Math.round(maxPrice)}
        className="relative flex h-5 w-[180px] touch-none select-none items-center"
      >
        <Slider.Track
          className={cn("relative h-[3px] grow rounded-full border br-[30px] bg-[#91caff]")}
        >
          <Slider.Range
            className={cn("absolute h-full rounded-full track")}
          />
        </Slider.Track>
        <Slider.Thumb
          className={cn("block size-5 rounded-[10px] bg-white focus:outline-none border-2 border-[#91caff]")}
          aria-label="min price"
        />
        <Slider.Thumb
          className={cn("block size-5 rounded-[10px] bg-white focus:outline-none border-2 border-[#91caff]")}
          aria-label="max price"
        />
      </Slider.Root>
      <input
        className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none bg-[#fff] rounded-[6px] border border-black/15 hover:bg-black/5 h-[20px] max-w-[40px] shrink-0 items-center justify-center bg-white text-center text-[14px] text-text outline-none transition-all"
        type="number"
        inputMode="numeric"
        autoFocus={false}
        autoCorrect="off"
        autoComplete="off"
        autoCapitalize="off"
        autoSave="off"
        value={Number(currentMax)}
        onChange={(event) => {
          onChangePrice([currentMin, Number(event.target.value)]);
        }}
      />
      <span className="text-[14px]">€</span>
    </p>
  );
}
